const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class Entrenchments extends Tactic {
    constructor() {
        super(
            Age.Age3,
            TacticNames.Entrenchments,
            [1, 0, 2],
            "9(5)",
            {}
        )
    }
}

module.exports = Entrenchments;